import {ActionType, createAction} from "typesafe-actions"
import Error from "../../shared/models/error"
import {RefDbDataContext} from "../models/displayDataContext"
import GenerateTableType from "../../shared/enums/generateTableType"
import {generalSettingsActions} from "../../settings/redux/actions/settings.actions"
import {TableSorting} from "../../@biocrates-common-repo/core/models/tableSorting"
import {ColumnWidth} from "../../@biocrates-common-repo/core/models/columnWidth"
import {TableFiltering} from "../../@biocrates-common-repo/core/models/tableFiltering"
import TableColumn from "../../@biocrates-common-repo/core/models/tableColumn"

export const errorAction = createAction("ERROR")<Error>()

export const setGenerateTableType = createAction(
    "displayData/SET_OUTPUT_TYPE"
)<GenerateTableType>()

export const setDisplayDataContextAction = createAction(
    "displayData/SET_CONTEXT"
)<RefDbDataContext>()

export const setMultipleContextAction = createAction(
    "displayData/SET_MULTIPLE_CONTEXT"
)<RefDbDataContext>()

export const removeFromMultipleContext = createAction(
    "displayData/REMOVE_FROM_MULTIPLE_CONTEXT"
)<number>()

export const setTableColumn = createAction("displayData/SET_TABLE_COLUMN")<
    TableColumn[]
>()

export const dataClean = createAction("data/CLEAN")<void>()

export const loadSpeciesAction = createAction("species/LOAD")<boolean>()
export const loadSpeciesSuccessAction = createAction("species/LOAD_SUCCESS")<
    any[]
>()

export const loadMaterialsAction = createAction("materials/LOAD")<boolean>()
export const loadMaterialsSuccessAction = createAction(
    "materials/LOAD_SUCCESS"
)<any[]>()
export const loadAssayAction = createAction("assay/LOAD")<boolean>()
export const loadAssaySuccessAction = createAction("assay/LOAD_SUCCESS")<
    any[]
>()
export const loadMetabolitesAction = createAction("metabolites/LOAD")<boolean>()
export const loadMetabolitesExternalAction = createAction(
    "metabolitesExternal/LOAD"
)<void>()
export const loadMetabolitesSuccessAction = createAction(
    "metabolites/LOAD_SUCCESS"
)<any[]>()
export const loadClassesAction = createAction("classes/LOAD")<boolean>()
export const loadClassesSuccessAction = createAction("classes/LOAD_SUCCESS")<
    any[]
>()

export const loadProjectsAction = createAction("projects/LOAD")<boolean>()
export const loadProjectsSuccessAction = createAction("projects/LOAD_SUCCESS")<
    any[]
>()

export const loadMatricesAction = createAction("matrices/LOAD")<boolean>()
export const loadMatricesSuccessAction = createAction("matrices/LOAD_SUCCESS")<
    any[]
>()

export const loadConfigurationAction = createAction(
    "configuration/LOAD"
)<string>()

interface Configuration {
    data: any[]
    type: string
}

export const loadConfigurationSuccessAction = createAction(
    "configuration/LOAD_SUCCESS"
)<Configuration>()

export const loadVariablesAction = createAction("variables/LOAD")<boolean>()
export const loadVariablesSuccessAction = createAction(
    "variables/LOAD_SUCCESS"
)<any[]>()

export const loadExistingVariablesAction = createAction(
    "existingVariables/LOAD"
)<void>()
export const loadExistingVariablesSuccessAction = createAction(
    "existingVariables/LOAD_SUCCESS"
)<any[]>()

export const loadValuesAction = createAction("values/LOAD")<string>()
export const loadValuesSuccessAction = createAction(
    "values/LOAD_SUCCESS"
)<any>()

export const loadDemographicsDataAction = createAction(
    "demographics/LOAD"
)<void>()
export const loadDemographicsDataSuccessAction = createAction(
    "demographics/LOAD_SUCCESS"
)<any[]>()

export const loadReferenceRangesDataAction = createAction(
    "referenceRanges/LOAD"
)<void>()
export const loadReferenceRangesInternalDataAction = createAction(
    "referenceRangesInternal/LOAD"
)<void>()

export const cancelReferenceRangesDataAction = createAction(
    "referenceRanges/CANCEL"
)<boolean>()

export const cancelReferenceRangesDataSuccessAction = createAction(
    "referenceRanges/CANCEL_SUCCESS"
)<boolean>()

export const loadReferenceRangesDataSuccessAction = createAction(
    "referenceRanges/LOAD_SUCCESS"
)<any[]>()

export const cleanDetectabilitySummaryDataAction = createAction(
    "detectabilitySummary/CLEAN"
)<void>()

export const loadDetectabilitySummaryDataAction = createAction(
    "detectabilitySummary/LOAD"
)<number>()
export const loadDetectabilitySummaryDataSuccessAction = createAction(
    "detectabilitySummary/LOAD_SUCCESS"
)<any>()
export const loadDateTableDataAction = createAction("dateTable/LOAD")<boolean>()
export const loadDateTableDataSuccessAction = createAction(
    "dateTable/LOAD_SUCCESS"
)<any[]>()

export const exportDisplayDataAction = createAction(
    "displayData/EXPORT"
)<string>()
export const exportDetectabilitySummaryAction = createAction(
    "detectabilitySummary/EXPORT"
)<void>()

export const exportDisplayDataSuccessAction = createAction(
    "displayData/EXPORT_SUCCESS"
)<Blob>()

// Settings

export const setDisplayDataSortingAction = (sorting: TableSorting[]) =>
    generalSettingsActions.updateTableSorting("sorting", sorting)

export const setDisplayDataFilteringAction = (filtering: TableFiltering[]) =>
    generalSettingsActions.updateTableFiltering("filtering", filtering)

export const setColumnWidthsAction = (widths: ColumnWidth[]) =>
    generalSettingsActions.updateColumnWidths("columnWidths", widths)

export const loadTotalNumberOfSamplesAction = createAction(
    "displayData/LOAD_TOTAL_OF_SAMPLES_NUMBER"
)<void>()

export const loadTotalNumberOfSamplesSuccessAction = createAction(
    "displayData/LOAD_TOTAL_OF_SAMPLES_NUMBER_SUCCESS"
)<number>()

export type RefdbActions = ActionType<
    | typeof errorAction
    | typeof loadSpeciesAction
    | typeof loadSpeciesSuccessAction
    | typeof loadMaterialsAction
    | typeof loadMaterialsSuccessAction
    | typeof loadAssayAction
    | typeof loadAssaySuccessAction
    | typeof loadClassesAction
    | typeof loadClassesSuccessAction
    | typeof loadMetabolitesAction
    | typeof loadMetabolitesExternalAction
    | typeof loadMetabolitesSuccessAction
    | typeof loadReferenceRangesDataAction
    | typeof loadReferenceRangesInternalDataAction
    | typeof cancelReferenceRangesDataAction
    | typeof cancelReferenceRangesDataSuccessAction
    | typeof loadReferenceRangesDataSuccessAction
    | typeof loadDetectabilitySummaryDataAction
    | typeof loadDetectabilitySummaryDataSuccessAction
    | typeof loadDateTableDataAction
    | typeof loadDateTableDataSuccessAction
    | typeof setDisplayDataContextAction
    | typeof loadVariablesSuccessAction
    | typeof loadVariablesAction
    | typeof loadExistingVariablesAction
    | typeof loadExistingVariablesSuccessAction
    | typeof loadProjectsAction
    | typeof loadProjectsSuccessAction
    | typeof loadMatricesAction
    | typeof loadMatricesSuccessAction
    | typeof loadConfigurationSuccessAction
    | typeof loadConfigurationAction
    | typeof exportDisplayDataAction
    | typeof exportDisplayDataSuccessAction
    | typeof exportDetectabilitySummaryAction
    | typeof setMultipleContextAction
    | typeof removeFromMultipleContext
    | typeof setGenerateTableType
    | typeof loadValuesAction
    | typeof loadValuesSuccessAction
    | typeof dataClean
    | typeof setDisplayDataSortingAction
    | typeof setDisplayDataFilteringAction
    | typeof setColumnWidthsAction
    | typeof loadTotalNumberOfSamplesAction
    | typeof loadTotalNumberOfSamplesSuccessAction
    | typeof loadDemographicsDataAction
    | typeof loadDemographicsDataSuccessAction
    | typeof setTableColumn
>
